import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Form, Button, Input, Select } from 'antd';
import { TOPICS } from '../../constants';

function NotificationsForm({ form, onSubmit, loading }) {
  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          onSubmit(values);
          form.resetFields();
        }
      });
    },
    [form, onSubmit],
  );

  const { getFieldDecorator } = form;
  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  };
  return (
    <Form {...formItemLayout} onSubmit={handleSubmit}>
      <Form.Item label="Messaggio">
        {getFieldDecorator('message', {
          rules: [{ required: true }],
        })(<Input.TextArea rows={4} />)}
      </Form.Item>

      <Form.Item label="Topic">
        {getFieldDecorator('topic', {
          rules: [{ required: true }],
        })(
          <Select>
            {TOPICS.map(topic => (
              <Select.Option value={topic}>{topic}</Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Invia
        </Button>
      </Form.Item>
    </Form>
  );
}

export default Form.create()(NotificationsForm);

NotificationsForm.propTypes = {
  form: PropTypes.shape({
    validateFields: PropTypes.func,
    getFieldDecorator: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
